module.exports = __webpack_public_path__ + "static/media/scr4.04d2793e.png";